var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 50",
    style: {
      enableBackground: "new 0 0 1000 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.33;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.66;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527,16.3c203.9-44.2,263.1,17,320.3,0C934-9.6,1000,20.1,1000,20.1V50H0l0-29.9c0,0,62.1-13.1,94.9-14.7 c32.8-1.7,62.8,6.2,75.8,11.1c23.3,8.7,84,29.1,134.4,31.1C355.5,49.6,507.6,20.5,527,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.9,34.9c200,29.9,266-34.1,395.1-10.2c129,24.3,129,22.4,186.2,14.5c56.8-7.9,52.5-12.7,94.9-16.6 C971.4,16.8,1000,50,1000,50H0c0,0,9.9-21.3,83.6-25.1S170.4,25.5,233.9,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266,14.9c45.5,0,77.2,12.1,129.1,20.4c28.6,4.5,150.3,5.3,254-20.4s91.7,17.9,149.2,0 c86-26.6,201.7,14.3,201.7,14.3V50H0l0-19c0,0,28.2,9.6,92.1,9.6C189.8,40.6,224.3,14.9,266,14.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.2bd8f7eb958f2f2e21c0aa4195d4ecd8.svg";
export { ForwardRef as ReactComponent };